import React, { useState } from 'react';

const SourceList = (props) => {
  const [sources, setSources] = useState(false);

    const getSources = async (text) => {
        setSources(await getTextFromSefaria(text, 'hebrew'));
      };

    return (
      <div className="source-list">
        <h2>Sources with Comments</h2>
        { 
            sources ? (
                <ul>
                    { 
                        sources.map((source, index) => (
                            <li key={index}>
                                <Link to= {{pathname: "/gemara", search:("?text=" + encodeURIComponent(source.title)) }}>{source.title} </Link>
                            </li>
                        ))
                    }
                </ul>
                ) : ""
            }
    </div>
  );
};

export default SourceList;